/*
 * True if an autoSizeSetting value means "shrink text to fit the shape". The
 * PowerPoint host returns this enum in inconsistent casing/prefixing across
 * builds ("AutoSizeTextToFitShape", "TextToFitShape", "autoSizeTextToFitShape"),
 * so normalize before comparing — a bare `=== "TextToFitShape"` never matches a
 * host that returns the prefixed form, which made set_text's overflow detector
 * always believe autofit was off. Pure, unit-tested.
 */
export function isShrinkToFit(v: unknown): boolean {
  return String(v ?? "")
    .toLowerCase()
    .includes("texttofitshape");
}
